// extracted by mini-css-extract-plugin
export var depositLimitLink = "ResponsibleGambling-module--depositLimitLink--81678";
export var responsibleGambling = "ResponsibleGambling-module--responsibleGambling--cbd1d";